import { version } from "vue";
const [major] = version.split(".").map(Number);
const VueVersion = major;
export {
  VueVersion
};
